<div
  class="attribute-editor-component youtube-component-container"
  rvSpinner="youtube-editor-loader"
  [rvShowSpinner]="spinner"
>
  <div class="attribute-editor-row youtube-source-row">
    <form>
      <div
        class="form-group has-feedback"
        [ngClass]="{
          'has-error': validationStatus && validationStatus !== 'VALID',
          'has-success': validationStatus === 'VALID' && source !== '',
        }"
      >
        <label for="te-youtube-src">Source</label>
        <p id="te-youtube-src-description" class="youtube-source-description">
          Your video(s) won't be shown in preview but will play on your Display.
        </p>
        <div class="youtube-source-input">
          <input
            type="text"
            id="te-youtube-src"
            name="te-youtube-src"
            class="form-control u_ellipsis"
            aria-describedby="te-youtube-src-description"
            [(ngModel)]="source"
            placeholder="Enter URL"
            (debounceEvent)="saveSource()"
            [disabled]="!termsAccepted"
          />
          @if (validating) {
            <span class="form-control-feedback youtube-source-spinner">
              <mat-spinner
                diameter="18"
                strokeWidth="1.8"
                aria-label="Checking the YouTube URL"
              ></mat-spinner>
            </span>
          } @else {
            <streamline-icon
              class="overlay-icon form-control-feedback"
              aria-hidden="true"
              name="{{
                validationStatus && validationStatus !== 'VALID'
                  ? 'exclamation'
                  : 'checkmark'
              }}"
              width="14"
              height="12"
            ></streamline-icon>
          }
        </div>
        <p class="help-block">
          @switch (validationStatus) {
            @case ('INVALID') {
              <span>Please provide a valid YouTube URL.</span>
            }
            @case ('VIDEO_NOT_FOUND') {
              <span>Video not found.</span>
            }
            @case ('PLAYLIST_NOT_FOUND') {
              <span>Playlist not found.</span>
            }
            @case ('CHANNEL_NOT_FOUND') {
              <span>Channel not found.</span>
            }
            @case ('NOT_EMBEDDABLE') {
              <span>Embedding of this Video is not allowed.</span>
            }
          }
        </p>
      </div>
      <div class="youtube-source-details" aria-live="polite">
        @if (validating) {
          <span class="sr-only">Checking the YouTube URL</span>
        }
        @if (sourceTypeLabel) {
          <span class="youtube-source-type">{{ sourceTypeLabel }}</span>
          @if (sourceType === 'video' && videoDuration) {
            <span>{{ videoDuration | videoDuration }}</span>
          }
          @if (sourceType === 'playlist' && playlistLength !== undefined) {
            <span>
              {{ playlistLength }}
              {{ playlistLength === 1 ? 'video' : 'videos' }}
            </span>
          }
        }
      </div>
    </form>
  </div>
  @if (showSourceSettings) {
    <div class="attribute-editor-row youtube-captions-row">
      <label id="te-youtube-captions-label" for="te-youtube-captions"
        >Subtitles</label
      >
      <mat-form-field
        appearance="outline"
        subscriptSizing="dynamic"
        class="tw-w-full"
      >
        <mat-select
          id="te-youtube-captions"
          [(ngModel)]="captions"
          aria-labelledby="te-youtube-captions-label"
          (ngModelChange)="saveCaptions()"
          [disabled]="!termsAccepted || loadingCaptions"
          canSelectNullableOptions
        >
          @for (option of captionOptions; track option.value) {
            <mat-option [value]="option.value">{{ option.label }}</mat-option>
          }
        </mat-select>
        @if (loadingCaptions) {
          <mat-spinner
            matSuffix
            class="youtube-captions-spinner"
            diameter="18"
            strokeWidth="1.8"
            aria-hidden="true"
          ></mat-spinner>
        }
        @if (captionsHint) {
          <mat-hint class="youtube-captions-hint">{{ captionsHint }}</mat-hint>
        }
      </mat-form-field>
      <span class="tw-sr-only" aria-live="polite">
        @if (loadingCaptions) {
          Loading subtitles
        }
      </span>
    </div>
    <div class="attribute-editor-row youtube-volume-row">
      <div id="youtube-component-volume">
        <label>Volume</label>
        <div class="row">
          <div class="col-xs-12">
            <input
              min="0"
              max="100"
              type="range"
              [(ngModel)]="volume"
              (change)="saveVolume()"
              [disabled]="!termsAccepted"
            />
          </div>
        </div>
        <p class="range-value">{{ volume }}</p>
      </div>
    </div>
  }
  @if (!termsAccepted) {
    <div class="terms-conditions py-3">
      <p class="px-3">
        This integration uses YouTube API Services. By using it, you agree to be
        bound by the
        <a
          rv-link
          appearance="inline"
          target="_blank"
          href="https://www.youtube.com/t/terms"
          >YouTube Terms of Service</a
        >
        and
        <a
          rv-link
          appearance="inline"
          target="_blank"
          href="http://www.google.com/policies/privacy"
          >Google Privacy Policy</a
        >. Rise Vision does not collect any personal data from YouTube.
      </p>
      <button rv-button type="button" (click)="acceptTerms()">Accept</button>
    </div>
  }
</div>
